import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Table from 'components/shared/table/table'
import THead from 'components/shared/table/table-header'
import TRow from 'components/shared/table/table-row'
import TCol from 'components/shared/table/table-column'
import TBody from 'components/shared/table/table-body'
import * as buildingTypes from 'actions/buildings/types'
import _ from 'lodash'

const OfficeTable = ({
  headers,
  fetchOfficesTable,
  id,
  areaUnit = 'sqft',
  officesTable = [],
  setShouldShowInquireModal,
}) => {
  useEffect(() => {
    if (id) fetchOfficesTable(id)
  }, [id])

  if (!officesTable.length) return <></>

  return (
    <div>
      <div className="building-separate mt-8 mb-6"></div>
      <div>
        <span className="text-black font-bold text-2xl">
          Other units available in this building
        </span>
      </div>
      <div className="md:mt-6 mt-2">
        <Table classes="w-full border-collapse">
          <THead classes="text-base text-primary-black font-semibold">
            {headers.map((header, key) => {
              let name = header.name
              const isPricePerSquareField = header.field === 'pricePerSquare'
              if (isPricePerSquareField) {
                name = `${name} ${areaUnit === 'sqft' ? 'Sqft' : 'Sqm'}`
              }
              return (
                <TCol align="center" classes="p-3 md:text-base text-sm" key={key}>
                  {name}
                </TCol>
              )
            })}
          </THead>
          <TBody classes="tbody-stripped w-full">
            {officesTable.map((osp, key) => {
              const {
                unit = '',
                asking_rent,
                size: { area_unit, floor_size },
                pricePerSquare = '',
              } = osp

              return (
                <TRow
                  key={key}
                  classes="border-t hover:bg-gray-100 px-2 md:text-base text-sm text-primary-black"
                >
                  <TCol align="center" classes="py-3">
                    {_.startCase(unit)}
                  </TCol>
                  <TCol align="center" classes="py-3">
                    <span>{floor_size}</span>{' '}
                    <span className="text-secondary-greypricetype">{area_unit}</span>
                  </TCol>
                  <TCol align="center" classes="py-3">
                    {pricePerSquare}
                  </TCol>
                  <TCol align="center" classes="py-3">
                    {asking_rent || <span>Inquire for rental price</span>}
                  </TCol>
                  <TCol align="center" classes="py-3">
                    <span
                      className="cursor-pointer"
                      onClick={() => {
                        setShouldShowInquireModal(true)
                      }}
                    >
                      <svg
                        width="25"
                        height="19"
                        viewBox="0 0 25 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M22.1499 0.0978546H2.64992C1.40918 0.0978546 0.399902 1.10714 0.399902 2.34787V15.8479C0.399902 17.0886 1.40918 18.0979 2.64992 18.0979H22.1499C23.3906 18.0979 24.3999 17.0886 24.3999 15.8479V2.34787C24.3999 1.10714 23.3906 0.0978546 22.1499 0.0978546ZM22.1499 1.59785C22.2518 1.59785 22.3487 1.61899 22.4373 1.65591L12.3999 10.3554L2.3624 1.65591C2.45103 1.61904 2.54797 1.59785 2.64987 1.59785H22.1499ZM22.1499 16.5978H2.64992C2.23611 16.5978 1.8999 16.2617 1.8999 15.8478V3.24067L11.9084 11.9147C12.0498 12.037 12.2249 12.0979 12.3999 12.0979C12.5749 12.0979 12.75 12.0371 12.8914 11.9147L22.8999 3.24067V15.8479C22.8999 16.2617 22.5637 16.5978 22.1499 16.5978Z"
                          fill="#38C7AD"
                        />
                      </svg>
                    </span>
                  </TCol>
                </TRow>
              )
            })}
          </TBody>
        </Table>
      </div>
    </div>
  )
}

OfficeTable.propTypes = {
  headers: PropTypes.array,
  officesTable: PropTypes.array,
  fetchOfficesTable: PropTypes.func,
  id: PropTypes.string,
  areaUnit: PropTypes.string,
  setShouldShowInquireModal: PropTypes.func,
}

OfficeTable.defaultProps = {
  headers: [
    { name: 'Unit', field: 'unit' },
    { name: 'Size', field: 'size' },
    { name: 'Price Per', field: 'pricePerSquare' },
    { name: 'Asking Rental', field: 'asking_rent' },
    { name: 'Inquire', field: 'inquire' },
  ],
}

const mapStateToProps = ({ building }) => ({
  officesTable: building.public.officesTable,
  areaUnit: building.public.details.area_unit,
})

const mapDispatchToProps = (dispatch) => ({
  fetchOfficesTable: (payload) =>
    dispatch({ type: buildingTypes.FETCH_BUILDING_OFFICE_TABLE, payload }),
})

export default connect(mapStateToProps, mapDispatchToProps)(OfficeTable)
